import { useCallback, MouseEvent, useRef, useState } from "react";
import { useNavigate } from "react-router";
import {
  Box,
  Button,
  Autocomplete,
  FormControl,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Typography,
} from "@mui/material";
import AppInput from "components/AppInput";
import ImageInput from "components/ImageInput";
import Resizer from "react-image-file-resizer";
import useGetImageUrl from "../hooks/useGetImageUrl";

/**
 * The ItemRegister page
 */
export default function ItemRegister() {
  const navigate = useNavigate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);

  const onClickBackLink = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      navigate("/items");
    },
    [navigate],
  );

  const uploadFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget?.files && e.currentTarget.files[0]) {
      const file = e.currentTarget.files[0];
      setImageFile(file);
    }
  };

  const { imageUrl } = useGetImageUrl({ file: imageFile });

  const [name, setName] = useState("");
  const [thumbnail, setThumbnail] = useState<string | null>(null);

  const resizeFile = (file: Blob): Promise<string> =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri as string);
        },
        "base64",
      );
    });

  const uploadFile2 = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (event.currentTarget?.files && event.currentTarget.files[0]) {
        const file = event.currentTarget.files[0];
        const image = await resizeFile(file);
        setThumbnail(image);
        setName(file.name);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <h2>
        <Typography fontSize={22}>新規登録</Typography>
      </h2>
      <form>
        <Box alignItems="center" display="flex" flexDirection="column">
          <AppInput labelName="id" type="number" />
          <AppInput labelName="janコード" type="number" />

          <Autocomplete
            options={[{ label: "ブランドA" }, { label: "ブランドB" }]}
            renderInput={(params) => (
              <AppInput
                {...params}
                labelName="ブランド"
                type="text"
                inputProps={{
                  ...params.InputProps,
                  inputProps: params.inputProps,
                }}
              />
            )}
          />

          <AppInput labelName="日付" type="date" />
          <AppInput labelName="時間" type="time" />
          {thumbnail ? (
            <img src={thumbnail} alt={name} />
          ) : (
            <Typography>アップロードする画像を選択してください</Typography>
          )}
          <ImageInput id="1" ref={fileInputRef} onChange={uploadFile2} />

          <FormControl>
            <Box display="flex" flexDirection="row">
              <Grid item xs={6} textAlign="center" container alignItems="center">
                <FormLabel>メーカー</FormLabel>
              </Grid>
              <Grid item xs={6}>
                <RadioGroup style={{ width: 150 }}>
                  <FormControlLabel value="メーカーA" control={<Radio />} label="メーカーA" />
                  <FormControlLabel value="メーカーB" control={<Radio />} label="メーカーB" />
                </RadioGroup>
              </Grid>
            </Box>
          </FormControl>
          <Button type="submit">登録</Button>
        </Box>
      </form>
      <a href="/items" onClick={onClickBackLink}>
        一覧に戻る
      </a>
      {/* <Link to="/list">一覧に戻る</Link> */}
      {/* <Route path='/list' element={<TestList />} /> */}
    </div>
  );
}
